module.exports = __webpack_public_path__ + "static/media/aurion-logo-blue.46f1121a.svg";